import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/ui/header';
import Footer from '@/components/ui/footer';

export const Route = createFileRoute('/_checkAuth/reactivar-cuenta')({
  component: () => <ReactivateAccountPage />,
});

function ReactivateAccountPage() {
  // Commented out original implementation
  // const [termsChecked, setTermsChecked] = useState(false);
  // const benefits = useAccountReactivateBenefits();

  return (
    <>
      <Helmet>
        <title>Reactivar Cuenta | MovieClub</title>
      </Helmet>
      <Header className="z-50" />
      <main className="sm:site-container z-0 flex min-h-[50vh] items-center justify-center">
        <div className="p-5 text-center">
          <h2 className="text-xl font-bold">El período de inscripción para la promoción ha finalizado.</h2>
        </div>
      </main>
      <Footer />
    </>
  );

  /* Original content
  return (
    <>
      <Helmet>
        <title>Reactivar Cuenta | MovieClub</title>
      </Helmet>
      <Header className="z-50" />
      <main className="sm:site-container z-0">
        <section className="mx-5 pb-10 sm:m-0">
          <Card className="overflow-hidden rounded-sm border bg-background shadow-sm">
            <img
              src="/img/account-reactivate-banner-july-2025-v2.png"
              alt="Reactivar Cuenta"
              className="h-auto w-full"
            />

            <div className="p-5 pb-16 sm:p-10">
              <h2 className="mb-2 text-xl font-bold text-secondary-hover">
                Volvé a disfrutar de estos beneficios exclusivos
              </h2>

              <div>
                {benefits.map((item, index) => (
                  <div key={index} className="mb-2 flex flex-col first:mt-5 [&>p]:text-sm">
                    <p className="!text-lg font-bold text-primary">{item.title}</p>
                    {item.description}
                  </div>
                ))}
                <p className="pt-5 text-sm text-muted-foreground">Descuentos aplicable en la tarifa vigente.</p>
              </div>

              <h2 className="mb-2 mt-5 text-xl font-bold text-secondary-hover">
                ¡Volvé ahora! Entrá a tu nuevo Club y salí al Cine
              </h2>

              <div className="my-5 h-[1px] w-full bg-border opacity-50"></div>

              <Link to={TERMS_AND_CONDITIONS} target="_blank" rel="noopener noreferrer" preload={false}>
                <Button className="p-0 text-sm" variant="link">
                  Ver Términos y Condiciones
                </Button>
              </Link>

              <div className="flex items-center gap-2">
                <Checkbox checked={termsChecked} id="terms" onClick={() => setTermsChecked(!termsChecked)} />
                <label htmlFor="terms"> estoy de acuerdo con los términos y condiciones</label>
              </div>

              <div className="mt-5">
                <Link
                  className={cn(
                    'w-full lg:max-w-60',
                    buttonVariants({
                      variant: 'default',
                      radius: 'full',
                    }),
                    {
                      'cursor-pointer': termsChecked,
                      '!bg-primary/60': !termsChecked,
                    },
                  )}
                  to="/registro"
                  search={{ redirect: '/reactivar-cuenta/callback' }}
                  preload={false}
                  disabled={!termsChecked}
                >
                  ¡Quiero reactivar mi cuenta!
                </Link>
              </div>

              <div className="mt-10 flex flex-col gap-1 text-sm text-muted-foreground">
                <p>Tenés tiempo para aprovechar la promo hasta el 10 de julio de 2025 inclusive.</p>
                <p>
                  *El valor promocional podrá ajustarse en caso de modificarse el precio base de la membresía,
                  manteniéndose el 50% de descuento vigente.
                </p>
              </div>
            </div>
          </Card>
        </section>
      </main>
      <Footer />
    </>
  );
  */
}
